<template>
  <div>
    <v-layout class="banner"></v-layout>
    <v-container class="intro">
      <v-row>
        <v-col cols="12" sm="12" md="6" class="intro-img"></v-col>
        <v-col cols="12" sm="12" md="6" class="inner">
          <h5 class="title-sm">Riiqo Storage</h5>
          <h1>So Much Control, Can You Handle it?</h1>
          <router-link to="contact" class="btn">Get Started</router-link>
        </v-col>
      </v-row>
    </v-container>

    <div class="riiqosxn riiqosxn-integrations">
      <v-container>
        <h1 class="riiqosxn-title">KEEP USING WHAT YOU ALREADY USE WITH OUR INTEGRATIONS</h1>
        <v-row>
          <v-col cols="12" sm="12">
            <div class="mod-integrations">
              <div class="mod-integrations__item item-google-calendar">
                <div class="item-icon"></div>
                <h5 class="item-title">Google Calendar</h5>
              </div>
              <div class="mod-integrations__item item-google-drive">
                <div class="item-icon"></div>
                <h5 class="item-title">Google Drive</h5>
              </div>
              <div class="mod-integrations__item item-google-docs">
                <div class="item-icon"></div>
                <h5 class="item-title">Google Docs</h5>
              </div>
              <div class="mod-integrations__item item-google-sheets">
                <div class="item-icon"></div>
                <h5 class="item-title">Google Sheets</h5>
              </div>
              <div class="mod-integrations__item item-google-analytics">
                <div class="item-icon"></div>
                <h5 class="item-title">Google Analytics</h5>
              </div>
              <div class="mod-integrations__item item-slack">
                <div class="item-icon"></div>
                <h5 class="item-title">Slack</h5>
              </div>
            </div>
            <div class="mod-integrations">
              <div class="mod-integrations__item item-stripe">
                <div class="item-icon"></div>
                <h5 class="item-title">Stripe</h5>
              </div>
              <div class="mod-integrations__item item-square">
                <div class="item-icon"></div>
                <h5 class="item-title">Square</h5>
              </div>
              <div class="mod-integrations__item item-paypal">
                <div class="item-icon"></div>
                <h5 class="item-title">Paypal</h5>
              </div>
              <div class="mod-integrations__item item-quickbooks">
                <div class="item-icon"></div>
                <h5 class="item-title">Quickbooks</h5>
              </div>
              <div class="mod-integrations__item item-woo">
                <div class="item-icon"></div>
                <h5 class="item-title">Woocommerce</h5>
              </div>
              <div class="mod-integrations__item item-shopify">
                <div class="item-icon"></div>
                <h5 class="item-title">Shopify</h5>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-users">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" class="col-left">
            <div class="riiqosxn-img"></div>
          </v-col>
          <v-col cols="12" sm="6" class="riiqosxn-content">
            <h1>Add Users and Create Groups</h1>
            <p>Manage all your users and quickly grant or remove permissions. You can add them to a group or multiple groups easily.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-permission">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" class="riiqosxn-content">
            <h1>Permission Controls</h1>
            <p>There are over 80 different permissions so you can make sure that your users only have access to what they should.</p>
          </v-col>
          <v-col cols="12" sm="6" class="col-left">
            <div class="riiqosxn-img"></div>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-phone">
      <v-container>
        <v-row class="row-content">
          <v-col cols="12" class="riiqosxn-content">
            <h1>Issue Phone Numbers</h1>
            <p>Get as many phone numbers you need so you can track your lead sources clearly. Use icons to represent them so you can easily see the source.</p>
          </v-col>
        </v-row>
        <v-row class="row-content">
          <div class="mod-social">
            <div class="mod-social__item texting">
              <div class="item-icon"></div>
              <h5 class="item-title">Texting</h5>
            </div>
            <div class="mod-social__item facebook">
              <div class="item-icon"></div>
              <h5 class="item-title">Facebook</h5>
            </div>
            <div class="mod-social__item linkedin">
              <div class="item-icon"></div>
              <h5 class="item-title">Linkedin</h5>
            </div>
            <div class="mod-social__item instagram">
              <div class="item-icon"></div>
              <h5 class="item-title">Instagram</h5>
            </div>
            <div class="mod-social__item google">
              <div class="item-icon"></div>
              <h5 class="item-title">Google</h5>
            </div>
            <div class="mod-social__item website">
              <div class="item-icon"></div>
              <h5 class="item-title">Website</h5>
            </div>
            <div class="mod-social__item socialmedia">
              <div class="item-icon"></div>
              <h5 class="item-title">Social Media</h5>
            </div>
          </div>
        </v-row>
      </v-container>
    </div>

    <div class="riiqosxn riiqosxn-chat">
      <div class="riiqosxn-img"></div>
      <v-container>
        <v-row class="row-f">
          <v-col cols="12" sm="7"></v-col>
          <v-col cols="12" sm="5" class="riiqosxn-content">
            <h1>Edit The Widget</h1>
            <p>Customize the buttons of your chat widget, and assign as many users and groups as you’d like to better service your customers. All of the changes you make in your settings will be updated in real time to your widget for smooth customer experience.</p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    
    <SxnCta />
  </div>
</template>

<script>
import { bus } from '../../../main'
import SxnCta from '../../commons/SxnCta'
export default {
  name: 'preferences',
  components: { SxnCta },
  data: () => ({
    
  }),
  mounted() {
		console.log(this.$route);
		bus.$emit('update-route', this.$route);
  }
};
</script>
